import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IndexedDBDexieService } from './core/indexedDB/service/indexed-db-dexie.service';
import { AuthService } from './core/service/auth.service';
import { AccessService } from './core/service/access.service'; 
import { localDB } from './shared/helpers/localStorage';
import { catchError, filter, forkJoin, lastValueFrom, of, Subscription } from 'rxjs';
import { CacheService } from './core/service/cache.service';
import { CookiesService } from './core/service/cookies.service';
import { REFRESH_INDEXED } from './core/indexedDB/helpers/enums.enums';
import { environment } from 'src/environments/environment';
import { SwPush } from '@angular/service-worker';
import { ConfigEnviromentService } from './core/service/configEnviroment.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'auditoria-medica-app';
  acceptedDomains: string[] = ['materiagris','dev','qa']
  public readonly VAPID_PUBLIC_KEY = 'BMYaMPu1sLX5PVA_pL5XlD8LUSbrGHHXqsJDAnA0sqxNfcH4hJ2KSk8exZKg_ANJcVCvQpZk1_zX5fek4aEiPO8';

  constructor(
    private _accessService: AccessService,
    private _authService: AuthService,
    private _router: Router,
    private _swPush: SwPush,
    private _dexieDB: IndexedDBDexieService,
    private _cacheService: CacheService,
    private _cookiesService: CookiesService,
    private configService: ConfigEnviromentService
  ){
  }
  
  ngOnInit() {
    this._dexieDB.initIndexDB()
    this.configService.configReady$.pipe(filter(isReady => isReady)).subscribe(() => {
      this.firstBackendConsult();
      this.itemsNavigationExist();
    })
    this._router.events.subscribe((data: any) => {
      if (!this._authService.isAuthenticated()) {
        let url = data.url;
        if (url && !url.includes('auth') && data.url != '/' ) {
          this._accessService.redirectionUrl$.next(url)
        }else{
          this._accessService.redirectionUrl$.next(null)
        }
      }
    });
    this.subscribeToNotifications();
  }
  
  firstBackendConsult(){
    forkJoin([
      this._accessService.newBackendTest().pipe(catchError(e => of({
        "data": 0,
        "isSuccess": false,
        "message": 'API NOT RESPONDE',
        "code": 500
      })))
    ]).subscribe((resp) => {
      if (resp.some(objeto => !objeto.isSuccess)) {
          resp.forEach(async (api) => {
            if(!api.isSuccess){
              let message = `%c${api.message}`;
              console.log(message, "color: red; font-size: 18px; background: yellow");
              if (this._authService.isAuthenticated()) {
                await this._cacheService.refreshAllValues();
                if (this._cookiesService.cookieNameEnv) {
                  this._cookiesService.deleteCookie(this._cookiesService.cookieNameEnv);
                }
               localStorage.clear();
                window.location.reload();
              }
            }
            
          })
      } else {

      }
    });
  }

  itemsNavigationExist() {
    if(this._authService.isAuthenticated()){
      if(localDB.getItem('aNavigationItem') && localDB.getItem('aSlugPermissions')){
        let aNavigationItem = JSON.parse(localDB.getItem('aNavigationItem'));
        if (aNavigationItem)
          this._accessService.setNavigationItems(aNavigationItem);
          let aSlugPermissions = JSON.parse(localDB.getItem('aSlugPermissions'));
          if (aSlugPermissions) this._accessService.setPermissions(aSlugPermissions);
      }else{
        this._accessService.routeLogin();
      }
    }


  }

  private keyCombination: Set<string> = new Set();

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    this.keyCombination.add(event.key);

    const isWindows = navigator.platform.includes('Win');
    const isMac = navigator.platform.includes('Mac');

    const isCtrlPressed = isWindows ? this.keyCombination.has('Control') : this.keyCombination.has('Meta');
    const isShiftPressed = this.keyCombination.has('Shift');
    const isRPressed = event.key === 'r' || event.code === 'KeyR';

    if (isCtrlPressed && isShiftPressed && isRPressed) {
      event.preventDefault();
      this.handleKeyCombination();
    }
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent) {
    this.keyCombination.delete(event.key);
  }

  private async handleKeyCombination() {
    await localDB.cleanCache(['horario', 'c-my-marks', 'c-red-button', 'c-extemp-marks', 'c-assistance', 'c-requests', 'celebrate-banner', 'c-tareo', 'c-requests-treasury']);
    
    await  lastValueFrom(
    forkJoin([
      this._dexieDB.refreshAllByTypeRefresh(REFRESH_INDEXED.ALWAYS),
      this._dexieDB.refreshAllByTypeRefresh(REFRESH_INDEXED.ALWAYS)
    ])
    );
      location.reload();
  }

  subscribeToNotifications(){
    if(environment.activePush){
    let userID = Number(localDB.getItem('idUsuario'))

    this._swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    }).then(sub => {
      const token = JSON.parse(JSON.stringify(sub));

      localDB.setItem("pushtoken", JSON.stringify(sub));
    

    }).catch(err => console.error('UPS:(', err))
  }
    }

}
